import { jwtDecode } from 'jwt-decode'

import { hasRoleFromGroup } from '@/utils/auth/roleGroups'

type AccessTokenClaims = {
  realm_access?: {
    roles?: string[]
  }
}

type LoginResponse = {
  data: { token: { accessToken: string } }
}

const INTEGRATION_ROLE = 'INTEGRATION'
const CLIENT_WEB_ROLES = ['USER', 'SUPERUSER', 'PRODUCT_SUPPLIER_USER']

export const WEB_ACCESS_DENIED_MESSAGE =
  'Веб-интерфейс недоступен для роли «Интеграция (УТ)»'

export class WebAccessDeniedError extends Error {
  constructor() {
    super(WEB_ACCESS_DENIED_MESSAGE)
    this.name = 'WebAccessDeniedError'
  }
}

export const getAccessTokenRoles = (accessToken: string) =>
  (jwtDecode<AccessTokenClaims>(accessToken).realm_access?.roles ?? []).map(
    (role) => role.toUpperCase()
  )

export const hasWebAccess = (tokenRoles: string[]) =>
  !tokenRoles.includes(INTEGRATION_ROLE) ||
  hasRoleFromGroup(tokenRoles, 'SUPPLIER_STAFF') ||
  tokenRoles.some((role) => CLIENT_WEB_ROLES.includes(role))

export const ensureWebAccess = <T extends LoginResponse>(response: T) => {
  if (!hasWebAccess(getAccessTokenRoles(response.data.token.accessToken))) {
    throw new WebAccessDeniedError()
  }
  return response
}
